// The staff CRM does not select a test workspace.
//
// Jacky, 2026-09-16: asked what the Live / Test set control in the header was for,
// and chose "Remove it from the staff CRM entirely."
//
// What that does and does not remove:
//   · The CONTROL is gone from the top bar. A staff member cannot put the CRM into a
//     marked workspace by accident and then wonder why the live book looks empty —
//     which is the failure this switch invited.
//   · The MECHANISM is untouched: ADR-006 marking, `aiw.current_test_set()`, the RLS
//     filter and the `x-aiw-test-set` header all still work for API clients, CI and
//     the harnesses that exercise a test set. Testing EmmA on marked data is done
//     through those, not through a staff dropdown.
//
// So `getTestSet()` answers null for this face by design, and any value left in a
// browser from before this change is cleared on first read rather than trusted.
const KEY = "aiw.crm.testSet";

export function getTestSet(): string | null {
  try {
    if (localStorage.getItem(KEY) !== null) localStorage.removeItem(KEY);
  } catch { /* private mode */ }
  return null;
}

/** Kept for the harnesses and tests that drive a marked workspace through this
 *  module; the staff UI never calls it any more. */
export function setTestSet(id: string | null): void {
  try { id ? localStorage.setItem(KEY, id) : localStorage.removeItem(KEY); } catch { /* private mode */ }
  window.dispatchEvent(new Event("aiw:testset"));
}
